import ColumnsContent from '../../../../../../components/Hocs/ColumnsContent';
import ContentMain from './ContentMain';
import RightSidebar from '../RightSidebar/RightSidebar';

export default ColumnsContent(ContentMain, RightSidebar);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentMain/index.js